/**
 * Module-level deduplication for concurrent GET requests to the same URL.
 * Entries auto-clear when the promise settles via .finally().
 *
 * This is a module-level singleton — intentionally shared across all grid
 * instances on the page. Two grids with the same gridCode SHOULD share
 * in-flight requests (same URL = same data).
 */
const inFlightRequests = new Map<string, Promise<unknown>>();
export function deduplicateGet<T>(url: string, request: () => Promise<T>): Promise<T> {
  const existing = inFlightRequests.get(url);
  if (existing !== undefined) {
    return existing as Promise<T>;
  }
  const promise = request().finally(() => {
    inFlightRequests.delete(url);
  });
  inFlightRequests.set(url, promise);
  return promise;
}